
<div class="mb-2">
    <a class="btn btn-secondary" [routerLink]="['/barrels']">&lt; Barrels</a>
</div>

<div *ngIf="Barrel != null; else Loading" class="card">
    <div class="card-header mfp-header">
        <div class="d-flex justify-content-between">
            <h4 class="d-inline-block align-self-center mb-0">
                Barrel: {{ Barrel.BarrelID }}
            </h4>
            <div class="d-inline-block">
                <button class="btn btn-secondary" (click)="EditBarrel()">Edit</button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-1">
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Orig. BBL #:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ Barrel.LegacyBarrelNumber }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Wood Type:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ WoodTypeDisplayValues[Barrel.WoodType] }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Is Used?
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ Barrel.IsUsed == null ? 'Unknown' : (Barrel.IsUsed ? 'Yes' : 'No') }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Char:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ Barrel.Char }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Toast:
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ ToastLevelDisplayValues[Barrel.ToastLevel] }}
                        </div>
                    </div>
                    <div class="row my-2">
                        <div class="col-12 col-md-6 fw-bold">
                            Description (Char):
                        </div>
                        <div class="col-12 col-md-6 text-end">
                            {{ Barrel.Description }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #Loading>
    
</ng-template>